import { useAuth } from "../AuthContext";
import { SKILLSTER_ORGANIZATION_ID, SKILLSTER_SCHOOL_ID } from "./constants";
import { isAdminRole } from "./role.helpers";

export function useIsAdminUser() {
  const { user } = useAuth();
  return isAdminRole(user);
}

export function useIsAdminUserOnSkillsterOrganization() {
  const isAdminUser = useIsAdminUser();
  const { selectedOrganizationId } = useAuth();
  return isAdminUser && selectedOrganizationId === SKILLSTER_ORGANIZATION_ID;
}

export function useIsAdminUserOnSkillsterSchool() {
  const isAdminUser = useIsAdminUser();
  const { selectedSchoolId } = useAuth();
  return isAdminUser && selectedSchoolId === SKILLSTER_SCHOOL_ID;
}
